import { setToken, removeToken } from '@utils/auth'
import {
    SET_TOKEN,
    SET_USER_INFO,
    SET_ROUTES,
    SET_ROLE,
    SET_COPYRIGHT,
    SET_LICENSE_NUMBER,
    SET_SYSTEM_NAME,
    SET_IS_INIT,
    SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE,
    SET_LOGIN_URL,
    SET_REGISTER_URL,
    SET_SUPERVISION_URL,
    SET_MARGIN_AMOUNT_STATISTICS,
    SET_TECHNICAL_SUPPORT,
    SHOW_COMPLAINTS,
    SHOW_CREDIT_PUBLICITY,
    SHOW_ENTERPRISE_CENTER,
    SHOW_HANDLING_GUIDE,
    SHOW_INDEX,
    SHOW_ORG_PUBLICITY,
    SHOW_POLICIES_REGULATIONS,
    SHOW_SUPERVISION_CENTER,
    SHOW_POLICY_VERIFICATION,
    
    SET_DOMAIN_NAME_TITLE,
    SET_VERSION
} from './mutation-types'

// import {asyncRouterMap} from '@router/routes'
import asyncRouterMap from '@router/asyncLoadRoutes'
import { ROLE, ROLE_ADMIN_ENUM } from '@config'
import systemInitializationService from '@service/systemInitializationService'


/**
 * 通过roles判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
    if (route.name) {
        return roles.includes(route.name)
    } else {
        return true
    }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param menus
 */
function filterAsyncRouter(routes, menus = []) {
    const res = []
    routes.forEach(route => {
        const tmp = { ...route }
        if (hasPermission(menus, tmp)) {
            // 子路由权限
            if (tmp.children) {
                tmp.children = filterAsyncRouter(tmp.children, menus)
            }
            res.push(tmp)
        }
    })

    return res
}

/**
 * 登录
 * @param commit
 * @param loginInfo
 * @returns {Promise<void>}
 */
export async function loginByUserName({ commit }, loginInfo) {
    // 获取账号密码信息
    // const {password} = loginInfo
    const newUserInfo = { ...loginInfo }
    /**
     *  // todo 临时处理
     *  // 发送登录请求
     *  const accessToken = await loginByUserNameService(newUserInfo)
     */
    const accessToken = 'TEST_TOKEN'

    commit(SET_TOKEN, accessToken)
    setToken(accessToken)
}

/**
 * 获取用户信息
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function getUserInfo({ commit }) {

    /**
     *  // todo 临时处理
     *  // 获取token
     *  const userInfo = await getUserInfoService()
     */

    const userInfo = {
        compCode: "",
        compName: "",
        name: "系统管理员",
        rule: "1"
    }



    /* ---todo demo 使用 开始 --- */
    const { rule } = userInfo
    const menus = rule === ROLE_ADMIN_ENUM ? ROLE.ADMIN : ROLE.USER
    /* ---todo demo 使用 结束--- */
    commit(SET_ROLE, menus)

    // 用户信息
    commit(SET_USER_INFO, userInfo)
}

/**
 * 登出系统
 * @param commit
 * @param state
 * @returns {Promise<void>}
 */
export async function logOut({ commit }) {
    commit(SET_ROLE, [])
    commit(SET_USER_INFO, null)
    commit(SET_TOKEN, '')
    removeToken()
}

/**
 * 生成路由表
 * @param commit
 * @param state
 * @param roles
 */
export function generateRoutes({ commit, state }) {
    // todo 临时注释
    // let role = state.role || []
    // let accessedRouters = []
    // if (role && role.length) {
    //     // 遍历获取 路由
    //     accessedRouters = filterAsyncRouter(asyncRouterMap, role)
    // }
    // commit(SET_ROUTES, accessedRouters)
    // return accessedRouters


    // --------
    commit(SET_ROUTES, asyncRouterMap)
    return asyncRouterMap
}
/**
 * 系统初始化
 * @param commit
 * @returns {Promise<void>}
 */
export async function initialization({ commit }) {
    const data = await systemInitializationService()
    const { copyright, licence_number, system_name, wages_version, login_url, register_url, supervision_url, redirect_mode, margin_amount_statistics, technical_support,
        show_complaints,
        show_credit_publicity,
        show_enterprise_center,
        show_handling_guide,
        show_index,
        show_org_publicity,
        show_policies_regulations,
        show_supervision_center,
        domain_name_title,
        show_policy_verification,
        version
    } = data || {}
    commit(SET_COPYRIGHT, copyright)
    commit(SET_LICENSE_NUMBER, licence_number)
    commit(SET_SYSTEM_NAME, system_name)
    commit(SET_PAYMENT_EARNEST_MONEY_MANAGEMENT_TYPE, wages_version)
    commit(SET_IS_INIT, true)
    commit(SET_LOGIN_URL, login_url)
    commit(SET_REGISTER_URL, register_url)
    commit(SET_SUPERVISION_URL, supervision_url)
    commit(SET_MARGIN_AMOUNT_STATISTICS, margin_amount_statistics)
    commit(SET_TECHNICAL_SUPPORT, technical_support)
    commit(SHOW_COMPLAINTS, show_complaints)
    commit(SHOW_CREDIT_PUBLICITY, show_credit_publicity)
    commit(SHOW_ENTERPRISE_CENTER, show_enterprise_center)
    commit(SHOW_HANDLING_GUIDE, show_handling_guide)
    commit(SHOW_INDEX, show_index)
    commit(SHOW_ORG_PUBLICITY, show_org_publicity)
    commit(SHOW_POLICIES_REGULATIONS, show_policies_regulations)
    commit(SHOW_SUPERVISION_CENTER, show_supervision_center)
    commit(SHOW_POLICY_VERIFICATION, show_policy_verification)

    commit(SET_DOMAIN_NAME_TITLE, domain_name_title)
    commit(SET_VERSION, version)

    
}